<template>
  <div class="group-root" :class="{ root }">
    <div class="name" :class="{ root }" @click="toggleOpen">
      <b-form-checkbox v-model="group._selected" @change="$emit('select', group)" :disabled="readOnly || ($attrs.id === group.id) || disabledGroups.includes($attrs.id)">
        {{ group.name }} <div v-if="$attrs.id === group.id" class="small d-inline">(Grupo actual)</div>
        <span v-if="group.status === groupStatus.INACTIVE" class="badge badge-pill badge-danger ml-1">Inactivo</span>
      </b-form-checkbox>
      <div class="show-subitems" v-show="group.subGroups && group.subGroups.length" :title="open ? 'Ocultar subgrupos' : 'Ver subgrupos'">
        <i class="fal fa-minus-circle" v-if="open"></i>
        <i class="fal fa-plus-circle" v-else></i>
      </div>
    </div>
    <div class="subgroups" v-show="open && group.subGroups && group.subGroups.length">
      <SubGroupSelectionTreeItem v-for="item in group.subGroups" :id="$attrs.id" :key="item.id" :group="item" :readOnly="readOnly" @select="$emit('select', $event)"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { GroupEntity, GroupStatus } from '@/types/catalogs/Groups'

@Component({
  name: 'SubGroupSelectionTreeItem'
})
export default class SubGroupSelectionTreeItem extends Vue {
  @Prop({ required: true })
  group: GroupEntity

  @Prop({ required: false, default: false })
  root: boolean

  @Prop({ required: false, default: true })
  opened: boolean

  @Prop({ required: false, default: false })
  readOnly: boolean

  open = false
  groupStatus = GroupStatus

  toggleOpen () {
    this.open = !this.open
  }

  created () {
    this.open = this.opened
  }

  get disabledGroups () {
    return this.group.allSubgroupIds.concat(this.group.siblingIds)
  }
}
</script>
